//import {test_function} from "./../functions/test_function.js";



import {getId} from "./../../universal_methods/getId.js";  
import {setId} from "./../../universal_methods/setId.js";
import {generateId} from "./../../universal_methods/generateId.js";
import {isEmpty} from "./../../universal_methods/isEmpty.js";  
import {getAttributes} from "./../../universal_methods/getAttributes.js";  
import {toggleDisplay} from "./../../universal_methods/toggleDisplay.js"; 

import { setTxt } from "../../universal_methods/setTxt.js";


export class SmetioPhotoAndDescription{
    
    constructor(data){
        

        this.getId = getId;
        this.setId = setId;     
        this.generateId = generateId;
        this.isEmpty = isEmpty;
        this.getAttributes = getAttributes;
        this.toggleDisplay = toggleDisplay;
        this.setTxt = setTxt;

        this.setId();
        // http://localhost:3000/img/placeholders/placeholderCoverImage.PNG

        this.photo = data.photo || "http://localhost:3000/img/home_page_front_photo_10.jpeg";
        this.alt = data.alt;
        this.description = data.description;
        this.orientation = data.orientation || "horizontal";
        this.autoSide = data.autoSide || "height";

        this.descriptionVPosition = data.descriptionVPosition || "top";
        this.boxWidth = data.boxWidth || "100%";
        this.boxMaxWidth = data.boxMaxWidth || "400px";
        this.boxMinWidth = data.boxMinWidth || "50px";
        this.boxHeight = data.boxHeight || "auto";
        this.boxMinHeight = data.boxMinHeight || "20px";
        this.boxMaxHeight = data.boxMaxHeight || "auto";

        this.photoWidth = data.photoWidth || "100px";
        this.photoHeight = data.photoHeight || null;
        this.photoVPosition = data.photoVPosition || "top";
        this.photoMaxHeight = data.photoMaxHeight || null;
        this.photoMinHeight = data.photoMinHeight || null;

        this.boxMargin = data.boxMargin || "10px";
        this.boxPadding = data.boxPadding || "10px";
        this.selectWidth = data.selectWidth || "20px";
        this.selectHeight = data.selectHeight || "20px";
        this.selectMargin = data.selectMargin || "10px";
        this.isSelected = data.isSelected || false;
        this.horizontalIsResponsive = data.horizontalIsResponsive || false;

        this.onClicked = data.onClicked || function(){};
        this.onSelected = data.onSelected || function(){};
        this.onDeselected = data.onDeselected || function(){};
        this.onMouseEnter = data.onMouseEnter;
        this.onMouseLeave = data.onMouseLeave;

        this.isHidden = data.isHidden || false;
        this.icon = data.icon;

        this.hidePhoto = data.hidePhoto ?? false;
     





        this.photoAndDescriptionClass = "smetio-photo-and-description-" + this.id;
        this.photoAndDescriptionAttributes = {
            id: this.id,
            "data-smetio-orientation": this.orientation,
            "data-smetio-width":this.boxWidth,
            "data-smetio-max-width": this.boxMaxWidth,
            "data-smetio-min-width": this.boxMinWidth,
            "data-smetio-height": this.boxHeight,
            "data-smetio-min-height": this.boxMinHeight,
            "data-smetio-max-height": this.boxMaxHeight,
            "data-smetio-margin": this.boxMargin,
            "data-smetio-padding": this.boxPadding,
            "data-smetio-auto-side": this.autoSide,
            "data-smetio-is-hidden": this.isHidden,
            "data-smetio-horizontal-responsive":this.horizontalIsResponsive,
            class: ["smetio-photo-and-description", this.photoAndDescriptionClass],
        };

        // photo
        this.photoClass = "smetio-photo-and-description-photo-" + this.id;
        this.photoAttributes = {
            "data-smetio-orientation": this.orientation,
            "data-smetio-width":this.photoWidth,
            "data-smetio-v-position": this.photoVPosition,
            // "data-smetio-min-height": this.photoMinHeight,
            // "data-smetio-max-height": this.photoMaxHeight,
            "data-smetio-auto-side": this.autoSide,
            "data-smetio-horizontal-responsive": this.horizontalIsResponsive,
            "data-smetio-is-visible": this.hidePhoto === false ? true : false,
            
            class: ["smetio-photo-and-description-photo", this.photoClass],
        };
        
        if(this.photoMinHeight) this.photoAttributes["data-smetio-min-height"] = this.photoMinHeight;
        if(this.photoMaxHeight) this.photoAttributes["data-smetio-max-height"] = this.photoMaxHeight;
        if(this.photoHeight) this.photoAttributes["data-smetio-height"] = this.photoHeight;
            

        // image
        this.imageClass = "smetio-photo-and-description-image-" + this.id;
        this.imageAttributes = {
            src: "http://localhost:3000/img/placeholders/placeholderCoverImage.PNG",
            alt: this.alt,
            "data-smetio-orientation": this.orientation,
            "data-smetio-width":this.photoWidth,
            "data-smetio-auto-side": this.autoSide,
            class: ["smetio-photo-and-description-image", this.imageClass],
        };

        if(this.photoMinHeight) this.imageAttributes["data-smetio-min-height"] = this.photoMinHeight;
        if(this.photoMaxHeight) this.imageAttributes["data-smetio-max-height"] = this.photoMaxHeight;
        if(this.photoHeight) this.imageAttributes["data-smetio-height"] = this.photoHeight;


        // description
        this.descriptionClass = "smetio-photo-and-description-description-" + this.id;
        this.descriptionAttributes = {
            "data-smetio-orientation": this.orientation,
            "data-smetio-v-position": this.descriptionVPosition,
            "data-smetio-auto-side": this.autoSide,
            class: ["smetio-photo-and-description-description", this.descriptionClass],
        };

        // selectStatus
        this.selectStatusClass = "smetio-photo-and-description-select-status-" + this.id;
        this.selectStatusAttributes = {
            "data-smetio-width":this.selectWidth,
            "data-smetio-height": this.selectHeight,
            "data-smetio-margin": this.selectMargin,
            "data-smetio-is-selected": this.isSelected,
            class: ["smetio-photo-and-description-select-status", this.selectStatusClass],
        };

    };

    select(){
        this.isSelected = true;
        $("."+this.selectStatusClass).attr("data-smetio-is-selected", this.isSelected);
        if(this.onSelected) this.onSelected();
    };

    deselect(){
        this.isSelected = false;
        $("."+this.selectStatusClass).attr("data-smetio-is-selected", this.isSelected);
        if(this.onDeselected) this.onDeselected();
    };



    getPhotosDescription(data={}){

        let {src, alt, description} = data;
        if( !this.isEmpty(src)) this.imageAttributes["src"] = src;
        if( !this.isEmpty(alt)) this.imageAttributes["alt"] = alt;

        description = this.setTxt({
            attributes: this.descriptionAttributes,
            txt: description || this.description,
            type: "html"
        });

        const icon = `<i class="smetio-icon smetio-icon-${this.icon}"></i>`;
        const image = `<img ${this.getAttributes(this.imageAttributes, false)}/>`;
        const photo = this.icon ? icon : image;

        return `
        <div ${this.getAttributes(this.photoAndDescriptionAttributes, false)}>

          <div ${this.getAttributes(this.selectStatusAttributes, false)}>
            <i class="smetio-icon smetio-icon-checkbox-checked"></i>
          </div>

          <div ${this.getAttributes(this.photoAttributes, false)}>
            ${photo}
          </div>

          <div ${this.getAttributes(this.descriptionAttributes, false)}>
            ${description}
          </div>

        </div>
      `;

        /* 
                  <h6 class="smetio-h6-heading"> I am a description. </h6>
            <p class="smetio-p-text"> I am a paragraph. And you are going to love me </p>
      */

    };
    
    hide(){
        $("."+this.photoAndDescriptionClass).attr("data-smetio-is-hidden", true);
    };

    show(){
        $("."+this.photoAndDescriptionClass).attr("data-smetio-is-hidden", false);
    };

    render() {

        this.events();

        setTimeout(() => {
            $(`.${this.imageClass}`).attr("src", this.photo);
        }, 700);

        return this.getPhotosDescription();
  
    };
  
    events() {
  
        $("body").on("mousedown", "."+this.photoAndDescriptionClass, ()=>{
  
            if(this.onClicked) this.onClicked({id: this.id});
  
        });	

        $("body").on("mouseenter", "."+this.photoAndDescriptionClass, ()=>{
  
            if(this.onMouseEnter) this.onMouseEnter({id: this.id});
  
        });	

        $("body").on("mouseleave", "."+this.photoAndDescriptionClass, ()=>{
  
            if(this.onMouseLeave) this.onMouseLeave({id: this.id});
  
        });	      
  
    };

};
